import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Schedule } from "@okeys/shared-utils"
import { ClockIcon } from "@radix-ui/react-icons"
import React, { useState } from "react"
import { ScheduleEditor } from "../../Common/ScheduleEditor"

type EditScheduleModalProps = {
  isOpen: boolean
  currentSchedule: Schedule
  onSave: (newSchedule: Schedule) => void
  onClose: () => void
}

export const EditScheduleModal: React.FC<EditScheduleModalProps> = ({
  isOpen,
  currentSchedule,
  onSave,
  onClose,
}) => {
  const [schedule, setSchedule] = useState<Schedule>(currentSchedule)
  const [isValid, setIsValid] = useState(true)

  const handleScheduleChange = (newSchedule: Schedule) => {
    setSchedule(newSchedule)

    // Validation simple - vérifier qu'au moins un jour a des horaires
    const hasValidSchedule = Object.values(newSchedule).some(
      (daySchedule) => daySchedule && daySchedule.length > 0
    )
    setIsValid(hasValidSchedule)
  }

  const handleSave = () => {
    if (isValid) {
      onSave(schedule)
      onClose()
    }
  }

  const handleCancel = () => {
    setSchedule(currentSchedule) // Reset to original
    onClose()
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-7xl min-w-[800px] max-h-[90vh] overflow-y-auto p-0 gap-0">
        <DialogHeader className="p-4 border-b border-gray-200">
          <DialogTitle className="flex items-center gap-2">
            <div className="p-1.5 bg-orange-100 rounded-lg">
              <ClockIcon className="h-4 w-4 text-orange-600" />
            </div>
            Modifier les horaires généraux
          </DialogTitle>
          <DialogDescription>
            Définissez les horaires d'ouverture généraux de votre boutique. Ces
            horaires s'appliqueront par défaut à tous les prestataires.
          </DialogDescription>
        </DialogHeader>

        <div className="p-4">
          <ScheduleEditor
            initialSchedule={currentSchedule}
            onScheduleChange={handleScheduleChange}
            className="max-h-[60vh] overflow-y-auto"
          />
        </div>

        <DialogFooter className="flex gap-2 p-4 border-t border-gray-200">
          <Button variant="outline" onClick={handleCancel}>
            Annuler
          </Button>
          <Button
            onClick={handleSave}
            disabled={!isValid}
            className="bg-black hover:bg-black/80 dark:bg-white dark:hover:bg-white/80 text-white dark:text-black"
          >
            Sauvegarder les horaires
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
